import React, { Component } from 'react';
import { Transition as ReactTransition } from 'react-transition-group';
import { historyExitingEventType, timeout } from '../../../gatsby-browser';

export default class Transition extends Component {
  constructor(props) {
    super(props);
    this.state = { exiting: false };
  }

  componentDidMount() {
    window.addEventListener(historyExitingEventType, this.listenerHandler);
  }

  componentWillUnmount() {
    window.removeEventListener(historyExitingEventType, this.listenerHandler);
  }

  static getDerivedStateFromProps({ exiting }) {
    if (exiting) {
      return { exiting: false };
    }
    return null;
  }

  listenerHandler = () => {
    this.setState({ exiting: true });
  };

  render() {
    const duration = timeout;
    const transitionStyles = {
      entering: {
        opacity: 0
      },
      entered: {
        opacity: 1,
        transition: `opacity ${duration}ms ease-out`
      },
      exiting: {
        opacity: 0,
        transform: 'translateY(-10vw)',
        transition: `all ${duration}ms ease-out`
      }
    };

    return (
      <ReactTransition in={!this.state.exiting} appear timeout={{ enter: 0, exit: timeout }}>
        {state => <div style={{ ...transitionStyles[state] }}>{this.props.children}</div>}
      </ReactTransition>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Transition/Transition.jsx